import styles from './index.module.sass';
import { EqualSign, ArrowMulti } from '../../images';

export const MixingStep = ({
  stepNumber,
  firstWarehouse,
  secondWarehouse,
  finalResult,
}: IMixingStep) => {
  return (
    <div className={styles.stepBody}>
      <div className={styles.stepNumber}>
        <span>{stepNumber}</span> шаг
      </div>
      <div className={styles.warehouse}>
        <span className={styles.warehouse__data}>
          <strong>{firstWarehouse.number}</strong>
          {firstWarehouse.title}
          {/* <span className={styles.price}>
            {Number(firstWarehouse.price).toLocaleString('RU-ru')} ₽
          </span> */}
        </span>
        <span className={styles.warehouse__weight}>
          <strong>{firstWarehouse.weight}</strong>т
        </span>
      </div>
      <div className={styles.separatorImage}>
        <img src={ArrowMulti} alt="icon" />
      </div>
      <div className={styles.warehouse}>
        <span className={styles.warehouse__data}>
          <strong>{secondWarehouse.number}</strong>
          {secondWarehouse.title}
          {/* <span className={styles.price}>
            {Number(secondWarehouse.price).toLocaleString('RU-ru')} ₽
          </span> */}
        </span>
        <span className={styles.warehouse__weight}>
          <strong>{secondWarehouse.weight}</strong>т
        </span>
      </div>
      <div className={styles.separatorImage}>
        <img src={EqualSign} alt="icon" />
      </div>
      <div className={styles.warehouse__result}>
        <span className={styles.warehouse__data}>
          <span className={styles.profit}>
            выгода на шаге{' '}
            <strong style={{color: "#007E3C"}}>{Number(finalResult.profit).toLocaleString('ru-RU', { maximumFractionDigits: 0 })} ₽</strong>
          </span>
          <strong>итог</strong>
          {Number(finalResult.price).toLocaleString('RU-ru', { maximumFractionDigits: 0 })} ₽
          
        </span>
        <span className={styles.warehouse__weight}>
          <strong>{finalResult.weight}</strong>т
        </span>
      </div>
    </div>
  );
};

interface IMixingStep {
  stepNumber: number;
  firstWarehouse: ISubStep;
  secondWarehouse: ISubStep;
  finalResult: ISubStep;
}

interface ISubStep {
  number: number | string;
  title: string;
  weight: number;
  price: string;
  profit?: string;
}
